import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/dating-through-dinner")({
  component: () => <Navigate to="/dating-app-alternative" replace />,
});
